import KeenSlider from 'keen-slider/keen-slider.cjs';

(function () {
  const keenSliderEl = document.querySelectorAll('.keen-slider');

  function ThumbnailPlugin(main) {
    return (slider) => {
      function removeActive() {
        slider.slides.forEach((slide) => {
          slide.classList.remove("active")
        })
      }
      function addActive(idx) {
        slider.slides[idx].classList.add("active")
      }

      function addClickEvents() {
        slider.slides.forEach((slide, idx) => {
          slide.addEventListener("click", () => {
            main.moveToIdx(idx)
          })
        })
      }

      slider.on("created", () => {
        addActive(slider.track.details.rel)
        addClickEvents()
        main.on("animationStarted", (main) => {
          removeActive()
          const next = main.animator.targetIdx || 0
          addActive(main.track.absToRel(next))
          slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
        })
      })
    }
  }

  /**
   * @param {HTMLElement} el
   */
  const createKeenSlider = (el) => {
    const { parentElement } = el;
    const thumbnails = parentElement.querySelector('.em-wp-block-slider__thumbnails');
    const mainSlider = new KeenSlider(el, {
      slide: {
        spacing: 15
      }
    });
    if (thumbnails) {
      new KeenSlider(
        thumbnails,
        {
          initial: 0,
          slides: {
            origin: 'center',
            perView: 4,
            spacing: 10,
          },
          vertical: true
        },
        [ThumbnailPlugin(mainSlider)]
      )
    }
  }

  keenSliderEl.forEach(el => createKeenSlider(el));

})();
